import { render, staticRenderFns } from "./MatchingPopUp.vue?vue&type=template&id=488b468a&scoped=true&"
import script from "./MatchingPopUp.vue?vue&type=script&lang=js&"
export * from "./MatchingPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MatchingPopUp.vue?vue&type=style&index=0&id=488b468a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b468a",
  null
  
)

export default component.exports